import React, { useCallback } from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { doChipStore } from '../../store/doChipStore';
import { favoriteBetsStore } from '../../store/favoriteBetsStore';
import { observer } from 'mobx-react-lite';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';

export const FavoriteBetFooter = observer(() => {
  const t = useTranslation();
  const { gameTypeId } = gameConfigStore;
  const { getAllBetsModels: allBetsModels } = doChipStore;

  const saveFavoriteBets = useCallback(() => {
    favoriteBetsStore.addFavoriteBet({ gameTypeId, favouriteBets: allBetsModels[0].betModel });
  }, [allBetsModels, gameTypeId]);

  return (
    <div className={`r-a-p-footer ${allBetsModels[0] ? '' : 'disabled'}`} onClick={saveFavoriteBets}>
      <div className='r-f-b-btn'>
        <p className='r-f-b-btn-text'>{t('SAVE')}</p>
      </div>
    </div>
  );
});
